<template>
  <div>
    <el-image style="width: 100px; height: 100px" @click="checkImage" :src="url" :preview-src-list="previewList">
    </el-image>
  </div>
</template>

<script>
import { GetQueryString } from '@/utils/utils.js'
export default {
  name: 'imagePreview',
  props: {
    // 默认展示的url
    url: {
      type: String,
      default: '',
    },
    previewList: {
      type: Array,
      default: []
    },
    needDownload: {
      type: Boolean,
      default: false,
    }
  },
  components: {},
  data() {
    return {
    }
  },
  created() {},
  methods: {
    checkImage() {
      console.log(this.needDownload)
      if (!this.needDownload) return false 
      this.$nextTick(() => {
        let a = document.querySelector('.el-image-viewer__actions__inner')
        var element = document.createElement('i')
        element.className = 'el-icon-download '
        a.append(element)
        element.addEventListener('click', this.installImage)
      })
    },
    installImage() {
      console.log(123123123)
    },
  },
}
</script>

<style lang="less" scoped>
</style>